import React from "react";
import TableMobileComponent from "./tableMobile";
import TableDesktopComponent from "./tableDesktop";

export default function Table({ headers = {}, list = [], pageNo = 1, size = 10 }) {
	const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

	// Update isMobile state when window is resized
	React.useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);


	return (
		<div className='overflow-x-auto  rounded-md'>
			{isMobile ? <TableMobileComponent headers={headers} list={list} pageNo={pageNo} size={size} /> : <TableDesktopComponent headers={headers} list={list} pageNo={pageNo} size={size} />}
		</div>
	);
}
